import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import "./i18n";
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import { NavbarContextProvider } from "./contexts/navbar-context";
import { AuthContextProvider } from "./contexts/auth-context";
import { ApprovalContextProvider } from "./contexts/approval-context";
import CustomizedSnackbar from "./components/Custom/CustomizedSnackbar";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./theme";
import { clarity } from "react-microsoft-clarity";
import * as Sentry from "@sentry/react";
import { CURRENT_VERSION } from "./config/variables";
import moment from "moment";
import "moment/locale/th";
import { history } from "./hooks/history";

moment.locale("th");

Sentry.init({
  dsn: "https://1dce4e66b7e945c3a1761207286f9d27@o4505345515913216.ingest.sentry.io/4505345533607936",
  release: "vpi-production@" + CURRENT_VERSION,
  integrations: [
    new Sentry.BrowserTracing({
      tracePropagationTargets: [
        "localhost",
        /^https:\/\/vpi-prod-api\.npr\.digital\/graphql/,
      ],
    }),
    new Sentry.Replay({
      maskAllText: false,
      maskAllInputs: false,
      blockAllMedia: false,
      networkDetailAllowUrls: ["https://vpi-prod-api.npr.digital/graphql"],
      networkRequestHeaders: ["X-Custom-Header"],
      networkResponseHeaders: ["X-Custom-Header"],
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  environment: process.env.REACT_APP_ENVIRONMENT,
});

clarity.init("hpectmpe5i");
clarity.consent();

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <HistoryRouter history={history}>
        <CustomizedSnackbar>
          <AuthContextProvider>
            <ApprovalContextProvider>
              <NavbarContextProvider>
                <App />
              </NavbarContextProvider>
            </ApprovalContextProvider>
          </AuthContextProvider>
        </CustomizedSnackbar>
      </HistoryRouter>
    </Provider>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
